import React, { useState, useEffect, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { ContainerFull, Container, ContainerAlign } from './styles';

import ModalPerfilPendente from '~/components/ModalPerfilPendente';

import { Breadcumbs } from '~/components/Breadcumbs';
import { BackButton } from '~/components/BackButton';

const DashboardEstratificacao = ({ location }) => {
  const { systemConfig } = useSelector(state => state.auth);

  const {
    urlSuperset,
    perfilInstituicaoPendente,
    dataUltimoPerfilInstituicao,
  } = systemConfig;

  const cpfUser = sessionStorage.getItem('cpf');
  const [linha, setLinha] = useState('clinicas_avc');
  const [title, setTitle] = useState('');

  const getTitle = useCallback(lc => {
    switch (lc) {
      case 'clinicas_avc':
        setTitle('Acidente Vascular Cerebral - AVC');
        break;

      case 'clinicas_geral':
        setTitle('Geral');
        break;

      case 'clinicas_sca':
        setTitle('Síndrome Coronariana Aguda - SCA');
        break;

      case 'clinicas_sepse':
        setTitle('Sepse e Choque Séptico');
        break;

      case 'clinicas_quadril':
        setTitle('Artropatia de Quadril');
        break;

      case 'clinicas_prostata':
        setTitle('Câncer de Próstata');
        break;

      case 'clinicas_mama':
        setTitle('Câncer de Mama');
        break;

      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (location?.pathname) {
      const path = location?.pathname?.replace('/estratificacao/', '');
      getTitle(path);
      setLinha(path);
    }
  }, [location]);

  return (
    <>
      <ModalPerfilPendente
        perfilInstituicaoPendente={perfilInstituicaoPendente}
        dataUltimoPerfilInstituicao={dataUltimoPerfilInstituicao}
      />
      <ContainerFull>
        <div className="ContainerBreadcumbs">
          <Breadcumbs
            path={linha}
            pathTitle={`Dashboard de Estratificação / ${title}`}
          />
          <ContainerAlign>
            <BackButton />
          </ContainerAlign>
        </div>
        <Container>
          <iframe
            id="frame"
            name="frame"
            title="SuperSet"
            src={`${urlSuperset}/login/?username=${cpfUser}&redirect=/superset/dashboard/${linha}/`}
            frameBorder="0"
          />
        </Container>
      </ContainerFull>
    </>
  );
};

export default DashboardEstratificacao;
